module.exports = __webpack_public_path__ + "img/yun1144.606df6a8.png";